<template>
  <div>

    <div class="mt-4">
      <div class="mb-3">
        <p class="text-primary-yellow font-semibold">
          <span>Coverage Details</span>
        </p>
      </div>

      <div class="flex flex-row flex-wrap lg:flex-nowrap">
        <div class="w-full lg:w-4/12 lg:pr-4">
          <label class="label">Select State</label>
          <el-select filterable v-model="state" placeholder="Select">
            <el-option label="--Select--" value="null">
            </el-option>
            <el-option v-for="state in states" :key="state.id" :label="state.name" :value="state.name">
            </el-option>
          </el-select>
        </div>
        <div class="w-full lg:w-8/12">
          <div class="routes-container flex flex-wrap  max-h-screen transition-all duration-500 pr-2"
            v-for="(route, index) in routes" :key="route" ref="route">

            <div class="lg:w-1/2 lg:px-2 w-full flex lg:-mt-1 xs:mt-3 ">
              <img class="cursor-pointer mr-2 lg:hidden w-6" :class="[routes.length > 1 ? 'opacity-100' : 'opacity-25']"
                @click="removeRoute(index)" src="@/assets/images/icons/delete-icon.svg" alt="" />
              <div class="flex gap-2 w-full">
                <div :style="{ width: 'inherit' }">
                  <label class="label">Reference Terminal</label>

                  <b-form-select v-model="route.terminal" class="mb-3">
                    <b-form-select-option value="null">-- Select --</b-form-select-option>
                    <b-form-select-option v-for="terminal in terminals" :key="terminal.id"
                      :value="{ id: terminal.id, name: terminal.locationName }">{{ terminal.locationName
                      }}</b-form-select-option>
                  </b-form-select>
                </div>

              </div>

            </div>

            <div class="w-full lg:w-1/2" :style="{ 'margin-top': '-2.5px' }">
              <label class="label">Add Coverage Areas</label>
              <div class=" w-full flex items-center gap-2">
                <form-select class="w-full" :placeholder="`${route.cities.length} Cities selected`">
                  <div class=" flex items-center gap-1">
                    <input class="checkbox" type="checkbox" @change="updateCheck($event, 'Select All', index)"
                      v-model="route.cities" />
                    Select All
                  </div>
                  <b-form-checkbox v-for="city in cities" :key="city" :name="city" :value="city" v-model="route.cities"
                    @change="updateCheck(city, index)" :label="city">
                    {{ city }}
                  </b-form-checkbox>
                </form-select>
                <img class="cursor-pointer mr-2 hidden lg:block w-7"
                  :class="[routes.length > 1 ? 'opacity-100' : 'opacity-25']" @click="removeRoute(index)"
                  src="@/assets/images/icons/delete-icon.svg" alt="" />
              </div>
            </div>

          </div>
          <div class="flex justify-end">
            <div v-if="!edit" class="flex justify-end">
              <button @click="addRoute"
                class="flex w-auto justify-center items-center font-semibold text-primary-yellow">
                <img src="@/assets/images/icons/add.svg" alt="add icon" class="mr-2" />
                Add another
              </button>
            </div>
          </div>

        </div>
        <div class="my-5">
          <div class="text-primary-yellow">Added Routes</div>
          <ol class="mx-2">
            <li v-for="(route, i) in routes" :key="i">
              {{ route.terminal.name }}
              <span v-if="route.cities[0]">to</span>
              {{ route.cities[0] }}<span v-if="route.cities[1]">,</span>
              {{ route.cities[1] }}
              <span v-if="route.cities.length > 2">+</span>{{ route.cities.length > 2 ? route.cities.length - 2 : "" }}
            </li>
          </ol>
        </div>
      </div>
    </div>

    <div class="button-wrapper">
      <p class="cursor-pointer" @click="$router.push({ name: 'Routes' })">
        Cancel
      </p>
      <base-button text="Create Route" :loading=isLoading v-if="!edit" @click="createRoute" />

      <base-button text="Update Route" :loading=isLoading v-else @click="updateRoute" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    states: {
      type: Array,
      default: () => [],
    },

    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      routeName: "",
      isLoading: false,
      routeMedium: "",
      state: null,
      cities: [],
      route: "",
      filteredCities: [],
      terminals: null,
      locations: [],
      takeOffLocation: "",
     shouldSelectAllBookings: false,
      routes: [
        {
          cities: [],
          terminal: {
            id: '',
            name: ''
          },
        },
      ],
    };
  },
  async mounted() {
    if (this.edit) {
      await this.getSingleRoute();
      let cities = this.route.routeCities
      let terminal = this.route.takeOff
      this.routes[0].cities = cities.map((city) => city.cityName)
      this.routes[0].terminal.id = terminal.id
      this.routes[0].terminal.name = terminal.locationName
    }

  },
  methods: {
    async updateCheck(event, city, index) {
      if (event.target.checked) {
        if (city == 'Select All') {
          this.routes[index].cities = []
          this.cities.forEach(async city => {
            this.routes[index].cities.push(city)

            if (this.edit) {
              // let cityId = this.route.routeCities.find((cit)=> cit.cityName === city).id
              try {
                await this.$_addCityToRoute({
                  payload: {
                    cityName: city,
                    orgId: localStorage.getItem("organizationId"),
                    userId: this.userId,

                  }
                }, this.route.id);
              } catch (error) {
                this.handleError();
              }
            }
          });
        } else {
          if (this.edit) {
            // let cityId = this.route.routeCities.find((cit)=> cit.cityName === city).id
            try {
              await this.$_addCityToRoute({
                payload: {
                  cityName: city,
                  orgId: localStorage.getItem("organizationId"),
                  userId: this.userId,

                }
              }, this.route.id);
            } catch (error) {
              this.handleError();
            }
          }
        }
      } else {
        if (city == 'Select All') {
          this.cities.forEach(async city => {
            this.routes[index].cities = []

            if (this.edit) {
              let cityId = this.route.routeCities.find((cit) => cit.cityName === city).id
              try {
                await this.$_deleteCityFromRoute(cityId);
              } catch (error) {
                this.handleError();
              }
            }
          });
        } else {
          if (this.edit) {
            let cityId = this.route.routeCities.find((cit) => cit.cityName === city).id
            try {
              await this.$_deleteCityFromRoute(cityId);
            } catch (error) {
              this.handleError();
            }
          }
        }

      }
    },
    async getSingleRoute() {
      try {
        let routeId = localStorage.getItem("routeId");
        const response = await this.$_getSingleRoute(routeId);

        this.route = response.data.data.shippingService;
      } catch (error) {
        this.handleError(error);
      }
    },

    addRoute() {
      let route = {
        cities: [],
        terminal: "",
      };
      this.routes.push(route);
      this.cities.push([]);
    },
    removeRoute(val) {
      if (this.routes.length <= 1) return;
      this.$refs.route[val].classList.add("max-h-zero");
      setTimeout(() => {
        this.routes = this.routes.filter((item, index) => index != val);
      }, 500);
    },
    async getTerminalsByState(state) {
      try {
        let response = await this.$_getTerminalsByState(state);
        this.terminals = response.data.getAllTerminals;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getCitiesByState(state) {
      try {
        const response = await this.$_getCitiesByState(state);
        console.log(JSON.stringify(response.data.cities, null, 2));
        this.cities = response.data.cities;
      } catch (error) {
        this.handleError(error);
      }
    },
    async createRoute() {
      try {
        this.isLoading = true
        console.log(JSON.stringify(this.payload, null, 2));
        await this.$_createRoute(this.payload);
        this.$router.push({ name: "Routes", query: { tab: 'doorToDoor' } });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false
      }
    },

    async updateRoute() {
      try {
        this.isLoading = true
        await this.$_updateRoute(this.editPayload, this.route.id);
        this.$router.push({ name: "Routes", query: { tab: 'doorToDoor' } });
      } catch (error) {
        this.handleError(error);
      } finally { this.isLoading = false }
    },
  },

  computed: {
    selectedRoute() {
      return this.routes.map((route) => {
        return {
          routeCities: route.cities,
          takeOffId: route.terminal.id,
        };
      });
    },
    payload() {
      return {
        payload: {
          orgName:
            this.$store.state.authentication.organizationDetails.companyname,
          orgId: localStorage.getItem("organizationId"),
          userId: this.userId,
          isIntrastate: true,
          isInterState: false,
          state: this.state,
          routes: this.selectedRoute,
          terminalType: "door-to-door",
        },
      };
    },
    editPayload() {
      return {
        payload: {
          orgName:
            this.$store.state.authentication.organizationDetails.companyname,
          orgId: localStorage.getItem("organizationId"),
          userId: this.userId,
          isIntrastate: true,
          isInterState: false,
          state: this.state,
          routeCities: this.selectedRoute[0].routeCities,
          takeOffId: this.selectedRoute[0].takeOffId,
          terminalType: "door-to-door",
        },
      };
    },
    userId() {
      let user = localStorage.getItem("loggedInUser");
      return JSON.parse(user).id;
    },
  },

  watch: {
    state: {
      handler(val) {
        this.getTerminalsByState(val);
        this.getCitiesByState(val);
      },
      deep: true,
    },
    route: {
      deep: true,
      immediate: true,
      handler(route) {
        if (route) {
          (this.routeName = route.routeName),
            (this.routeMedium = route.shippingMethod),
            (this.state = route.state),
            (this.cities = route.cities);
          this.terminal = route.referenceTerminal;
        }
      },
    },
  },
};
</script>

<style scoped>
.max-h-zero {
  max-height: 0;
}

.routes-container {
  animation: 3s 1 linear pop-height;
}

@keyframes pop-height {
  from {
    max-height: 0;
  }

  to {
    max-height: 100vh;
  }
}
.checkbox {
  width: 1rem;
  height: 1rem;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-color: #e5e7eb;
  /* gray */
  border: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
}

.checkbox:checked {
  background-color: #facc15;
  /* your yellow */
}

.checkbox:checked::after {
  content: "";
  margin-top: -2px;
  width: 0.35rem;
  height: 0.7rem;

  border: solid white;
  border-width: 0 2px 2px 0;

  transform: rotate(45deg);
  display: block;
}
</style>
